import {
  FinalValuation,
  Valuation,
  EstimateLogValuation,
} from '@popety-io/types'

export const calculateFinalValuation = (
  logValuation: EstimateLogValuation | null,
  valuations: Valuation[]
): FinalValuation => {
  if (!logValuation) {
    return { value: 0, range: { min: 0, max: 0 } }
  }

  // Check if there's a specific final valuation field
  if ((logValuation as any).finalValuation) {
    const final = (logValuation as any).finalValuation
    return {
      value: final.value || final.estimatedValue || 0,
      range:
        final.range ||
        (final.min && final.max
          ? { min: final.min, max: final.max }
          : { min: 0, max: 0 }),
    }
  }

  // If no specific final valuation, calculate from available AVM data
  if (valuations.length === 0) {
    return { value: 0, range: { min: 0, max: 0 } }
  }

  // Use the first valuation as the final value (typically the primary AVM)
  const primaryValuation = valuations[0]

  // Calculate average if multiple valuations available
  if (valuations.length > 1) {
    const totalValue = valuations.reduce((sum, val) => sum + val.value, 0)
    const averageValue = Math.round(totalValue / valuations.length)

    // Calculate range from min/max of all valuations
    const allValues = valuations.map((v) => v.value)
    const minValue = Math.min(...allValues)
    const maxValue = Math.max(...allValues)

    return {
      value: averageValue,
      range: { min: minValue, max: maxValue },
    }
  }

  return {
    value: primaryValuation.value,
    range: primaryValuation.range || { min: 0, max: 0 },
  }
}
